<template>
  <div class="pb-8 pt-2 white--text">
    <div class="overline white--text">Voyages</div>
    <div class="d-flex flex-column-reverse">
      <div
        v-for="(voyage, index) of containerMovements.voyages"
        :key="index"
      >
        <MobileContainerTrackingSearchResultItemVoyage
          class="mb-4"
          :voyage="voyage"
          :current-port-code="containerMovements.currentPortCode"
        />
      </div>
    </div>
    <div class="overline white--text">Activity Tracking</div>
    <MobileContainerTrackingSearchResultItemState
      class="mb-4"
      :logs="containerMovements.stepLogs"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MobileContainerTrackingSearchResultItemState from './MobileContainerTrackingSearchResultItemState.vue';
import MobileContainerTrackingSearchResultItemVoyage from './MobileContainerTrackingSearchResultItemVoyage.vue';
export default {
  components: {
    MobileContainerTrackingSearchResultItemVoyage,
    MobileContainerTrackingSearchResultItemState,
  },
  props: ['movement'],
  data: () => ({}),
  computed: {
    ...mapState('vsl/containerTracking', ['containerMovements']),
    movementDateRange() {
      const pocs = this.movement.pocs;
      const startDate =
        pocs[0] && this.$filters.formatDate(pocs[0].estimatedTime);
      const endDate =
        pocs[pocs.length - 1] &&
        this.$filters.formatDate(pocs[pocs.length - 1].estimatedTime);
      return `${startDate} - ${endDate}`;
    },
  },

  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
:deep {
}
</style>
